import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {DeltaDateConstraint} from "@tj/tj-dmp-lib-api";
import {SelectItem} from "primeng/api";

@Component({
    selector: 'dmp-delta-date',
    templateUrl: './delta-date.component.html',
    styleUrls: ['./delta-date.component.scss'],
    standalone: false
})
export class DeltaDateComponent implements OnInit, OnChanges {
    @Input() value: any[] | null = null;
    @Input() disabled: boolean = false;
    @Output() valueChange = new EventEmitter();
    public deltaType;
    public unit: DeltaDateConstraint.TypeEnum;
    public delta = 0;
    @Input() excludeYear = false;
  constructor() {
      this.deltaType = [
          {label: "Heure",value: DeltaDateConstraint.TypeEnum.HOUR},
          {label: "Jour",value: DeltaDateConstraint.TypeEnum.DAY},
          {label: "Semaine",value: DeltaDateConstraint.TypeEnum.WEEK},
          {label: "Mois",value: DeltaDateConstraint.TypeEnum.MONTH},
          {label: "Année",value: DeltaDateConstraint.TypeEnum.YEAR}
      ] as SelectItem[];
  }

  ngOnInit(): void {
      if (this.value != null && Array.isArray(this.value)) {
          this.unit = this.value[0];
          this.delta = this.value[1];
      } else {
          this.unit = DeltaDateConstraint.TypeEnum.HOUR;
          this.delta = -6;
          this.update();
      }
  }

    ngOnChanges(changes: SimpleChanges): void {
        this.updateExcludeYear();
    }

    protected update() {
      this.valueChange.emit([this.unit, this.delta]);
    }

    private updateExcludeYear(): void {
        // sans l'année, une période d'un an ou plus couvre tous les jours : l'unité Année n'a pas de sens
        this.deltaType = this.deltaType.map(item => ({
            ...item,
            disabled: this.excludeYear && item.value === DeltaDateConstraint.TypeEnum.YEAR
        }));
    }
}
